export default __webpack_public_path__ + "static/media/ecart1.fdf7b0e9.png";